/**
 * Created by ma.rongqin on 2016/11/7.
 */
"use strict";
angular.module("productManageMentAppNewTagModule", [])
    .controller("productManageMentAppNewTagCtrl", ["$scope", "$q", "trsHttpService", "modalDialog", "$validation", "$modalInstance", "item", "siteid",
        function($scope, $q, trsHttpService, modalDialog, $validation, $modalInstance, item, siteid) {
            initStatus();
            initData();

            function initStatus() {
                $scope.info = {
                    title: item ? '修改标签' : '新建标签',
                    siteid: siteid
                };

                $scope.data = {
                    currTag: {},
                };
                $scope.checkShowLabel = true;
                $scope.tagList = [];
            }

            function initData() {
                /*if (item) {
                    getcurrTag();
                }*/
                initTagList();
            }
            /**
             * [getcurrTag description 获取标签详细信息]
             * @return {[type]} [description]
             */
            function getcurrTag() {
                var params = {
                    "serviceid": "mlf_appconfig",
                    "methodname": "getLable",
                    "APPLABELID": item.APPLABELID
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.currTag = data;
                    var i = 0;
                    while (i < $scope.tagList.length) {
                        if ($scope.tagList[i].value === data.SYSORDER) {
                            $scope.tagList.splice(i, 1);
                            $scope.selectedTag = angular.copy($scope.tagList[i - 1]);
                        } else {
                            i++;
                        }
                    }
                });
            }
            /**
             * [initTagList description 获取标签列表]
             * @return {[type]} [description]
             */
            function initTagList() {
                var params = {
                    serviceid: "mlf_appconfig",
                    methodname: "queryLabels",
                    SITEID: siteid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    for (var i = 0; i < data.length; i++) {
                        $scope.tagList.push({
                            name: data[i].LABELNAME,
                            value: data[i].SYSORDER
                        });
                    }
                    $scope.tagList.unshift({
                        name: "最前面",
                        value: -1
                    });
                    $scope.selectedTag = $scope.tagList[0];
                    item !== "" ? getcurrTag() : "";
                });
            }
            /**
             * [checkLabel 标签校验重名]
             * @return {[type]} [description]
             */
            $scope.checkLabel = function() {
                if($scope.data.currTag.LABELNAME === "") return;
                var params = {
                    serviceid: "mlf_appconfig",
                    methodname: "isValidLabel",
                    SITEID: siteid,
                    LABELNAME: $scope.data.currTag.LABELNAME
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.checkShowLabel = data.slice(1,-1);
                });
            };
            /**
             * [cancel description 取消]
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss("cancel");
            };
            /**
             * [confirm description 确定]
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                if($scope.checkShowLabel == "false"){
                    modalDialog.alertType('标签名称重复', "请检查填写项", "warning", false);
                    return;
                }
                $validation.validate($scope.newTagForm).success(function() {
                    savecurrTag();
                }).error(function() {
                    modalDialog.alertType('保存失败', "请检查填写项", "warning", false);
                });
            };
            /**
             * [savecurrTag description 保存]
             * @return {[type]} [description]
             */
            function savecurrTag() {
                var params = {
                    serviceid: "mlf_appconfig",
                    methodname: "saveLabel",
                    APPLABELID: item ? item.APPLABELID : 0,
                    Siteid: siteid,
                    LABELNAME: $scope.data.currTag.LABELNAME,
                    LABELDESC: $scope.data.currTag.LABELDESC,
                    SysOrder: $scope.selectedTag.value,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    modalDialog.alertType('保存成功', "", "success", false, function() {
                        $modalInstance.close(data);
                    });
                });
            }
        }
    ]);
